import React from "react";
import * as URL from "./UrlConstants";
import Login from "../views/User/Login/Login";
import ForgetPassword from "../views/User/Password/Forget/ForgetPassword";
import NewPassword from "../views/User/Password/New/NewPassword";

export default [
	{
		path: URL.LOGIN_VIEW_PATH,
		element: <Login />,
		seoTitle: "Page de connexion - mon bureau d'études.",
		seoDescription: "Accédez à votre espace mon bureau d'études. pour consulter vos devis, suivre vos études structure et gérer vos documents en toute simplicité.",
	},
	{
		path: URL.FORGOT_PASSWORD_VIEW_PATH,
		element: <ForgetPassword />,
	},
	{
		path: URL.NEW_PASSWORD_VIEW_PATH,
		element: <NewPassword />,
	},
];
